<ng-container *transloco="let t">
  <section
    class="featured-reviews-item"
    [class.widescreen]="(biggerThan$ | async)?.sm"
    [class.dark-mode]="darkMode">
    <section class="wrapper">
      <section class="author-block">
        <span class="row author-wrap">
          <span class="author bold">{{ review?.author }}</span>
          <span>{{ t('label_verified') }}</span>
          <popsy-icon-tick-outlined
            class="icon gray-dark"
            [class.white-stroke]="darkMode"></popsy-icon-tick-outlined>
        </span>
        <span class="model-wrap flex">
          <span>{{ t('label_bought') }}</span>
          <span class="fixed-space-8" aria-hidden="true"></span>
          <a [routerLink]="urlFragments" [queryParams]="queryParameters" class="link">
            {{ review?.model }}
          </a>
        </span>
      </section>

      <span class="fixed-space-32" aria-hidden="true"></span>

      <section class="block author">
        <span class="row rating-wrap">
          <popsy-icon-star-filled
            *ngFor="let n of ratingIterate; trackBy: trackByIndex"
            class="icon fill-primary"
            [class.white]="darkMode"></popsy-icon-star-filled>
          <popsy-icon-star-half-filled
            class="icon fill-primary"
            *ngIf="isAverageRatingPointFive"></popsy-icon-star-half-filled>
        </span>

        <span class="col description">
          {{ readMore ? review?.description : (review?.description | slice: 0 : 150) }}
          <span *ngIf="!readMore && (review?.description?.length || 0) > 150">...</span>
          <span class="fixed-space-16" aria-hidden="true"></span>
          <span
            *ngIf="!readMore && (review?.description?.length || 0) > 150"
            class="readmore"
            (click)="readMore = true">
            {{ t('label_read_more') }}</span
          >
        </span>
      </section>
    </section>
  </section>
</ng-container>
